/*
 * Peel Why Peel — the scroll reveal for the philosophy page.
 *
 * The bands fade up as they come into view. Depends on peel-common.js
 * (peelInitScrollReveal) being loaded first, which is what gates it: the
 * bands are visible from the start if either file never arrives, since
 * the hidden state is set by the observer's own attribute rather than by
 * the markup. The hero is left out — it is above the fold, and fading in
 * the first thing on the page reads as a slow load rather than a reveal.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.peelInitScrollReveal !== 'function') return;
    window.peelInitScrollReveal([
      '.peel-why-split-outer',
      '.peel-why-protection-outer',
      '.peel-why-range-outer',
      '.peel-why-invitation-outer'
    ]);
  });
})();
